var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M312-696q-20 0-34 14t-14 34q0 20 14 34t34 14q20 0 34-14t14-34q0-20-14-34t-34-14Zm0 384q-20 0-34 14t-14 34q0 20 14 34t34 14q20 0 34-14t14-34q0-20-14-34t-34-14ZM192-816h576q20.4 0 34.2 13.8Q816-788.4 816-768v240q0 20.4-13.8 34.2Q788.4-480 768-480H192q-20.4 0-34.2-13.8Q144-507.6 144-528v-240q0-20.4 13.8-34.2Q171.6-816 192-816Zm24 72v192h528v-192H216Zm-24 312h576q20.4 0 34.2 13.8Q816-404.4 816-384v240q0 20.4-13.8 34.2Q788.4-96 768-96H192q-20.4 0-34.2-13.8Q144-123.6 144-144v-240q0-20.4 13.8-34.2Q171.6-432 192-432Zm24 72v192h528v-192H216Zm0-384v192-192Zm0 384v192-192Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArch);
export default __webpack_public_path__ + "static/media/arch.adb6933cfdc6d6006f0ed784108ee25f.svg";
export { ForwardRef as ReactComponent };